import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Stack,
  Paper
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
 

const TOTAL_STEPS = 8;

const Step5InterestedInSelection = ({
  onBack,
  onNext,
  selectedInterest,
  setSelectedInterest,
  currentStep = 5,
  showHeader = true,
  className
}) => {
  const handleSelect = (interest) => {
    setSelectedInterest(interest);
    onNext(); // Go to next step
  };

  const renderSegmentedProgressBar = () => {
    return (
      <Box display="flex" gap={1} mb={1}>
        {Array.from({ length: TOTAL_STEPS }).map((_, index) => (
          <Box
            key={index}
            flex={1}
            height={4}
            borderRadius={5}
            sx={{
              backgroundColor: index < currentStep ? '#0D99FF' : '#e0e0e0',
              transition: 'background-color 0.3s ease',
            }}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box display="flex" alignItems="start" justifyContent="center" className={className} sx={{ paddingTop: { xs: 0, sm: 13, md: 6, }, paddingBottom: { xs: 0, sm: 3, md: 6, }, }}>
      <Paper elevation={3} sx={{ p: { xs: '20px 15px', sm: 4, }, maxWidth: 480, width: '100%', borderRadius: { xs: '0', sm: '8px', md: '8px', boxShadow: 'none', }, position: 'relative', }}>
  {showHeader && (
       <> 
        {/* Progress Bar */}
        {renderSegmentedProgressBar()}

        {/* Back Button */}
        <IconButton onClick={onBack}>
          <ArrowBackIosNewIcon />
        </IconButton>
      
        </>
  )}
        {/* Heading */}
        <Typography
          variant="h5"
          fontWeight={600}
          mb={1.5}
          align="center"
          fontFamily="ivypresto-headline, serif"
        >
          Who are you interested in?
        </Typography>

        {/* Interest Buttons */}
        <Stack spacing={2}>
          {['Men', 'Women', 'Both', 'Non-binary/Other'].map((interest) => (
            <Button
              key={interest}
              variant={selectedInterest === interest ? 'contained' : 'outlined'}
              onClick={() => handleSelect(interest)}
              fullWidth
              sx={{
                py: 1,
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500,
                maxWidth: '200px',
                margin: '8px auto !important',
                border: selectedInterest === interest ? '1px solid #2B1E1A' : '1px solid #CFD9DE',
                backgroundColor: selectedInterest === interest ? '#2B1E1A' : 'transparent',
                color: selectedInterest === interest ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: selectedInterest === interest ? '#2B1E1A' : '#f5f5f5',
                },
              }}
            >
              {interest}
            </Button>
          ))}
        </Stack>
      </Paper>
    </Box>
  );
};

export default Step5InterestedInSelection;
